import apiClient from '../apiClient';
import { POST_SYSTEM_MARGIN_URL } from '../apiUrl';

const postSystemMarginApi = data => {
  return apiClient.post(POST_SYSTEM_MARGIN_URL, data);
};

export default postSystemMarginApi;
